import { uploadEntityAttachments, fetchEntityAttachments, updateAttachment, deleteAttachment } from '@/lib/entity-attachments';

export interface TeamMemberAttachment {
  id: string;
  file_name: string;
  file_type: string;
  file_size: number;
  file_url: string;
  created_at: string;
  created_by: string;
  created_by_user?: {
    display_name?: string | null;
  };
}

export async function uploadTeamMemberAttachments(
  teamMemberId: string | undefined,
  files: File[],
  companyId: string,
  userId: string
): Promise<TeamMemberAttachment[]> {
  return uploadEntityAttachments('user', teamMemberId, files, companyId, userId, { metadata: { document_type: 'team_member_document' } });
}

export function deleteTeamMemberAttachment(
  attachmentId: string,
  userId: string | undefined
): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}

export async function fetchTeamMemberAttachments(
  recordId: string,
  companyId: string
): Promise<TeamMemberAttachment[]> {
  if (!recordId || !companyId) return [];
  return fetchEntityAttachments('user', recordId, { documentType: 'team_member_document', ascending: false });
}

